const getAttributes = require('../getAttributes');

/**
 * An object representation of an element, formatted for React rendering.
 * @typedef  {Object} ElementMap
 * @property {String} tag The element's tag.
 * @property {*} children The element's content (relevant mainly for text elements).
 */

/**
 * A list of "deeply nested" elements, i.e. elements that require having element children in order to work properly.
 * @type {String[]}
 */
const DEEP_ELEMENTS = [
    'linearGradient',
    'radialGradient'
];

/**
 * Recursively traverses an element and maps all of the leaves in the element tree.
 * @param  {HTMLElement} element The element to traverse.
 * @param  {*} attributes An object of attributes to add to children element down the tree.
 * @return {ElementMap[]}
 */
const mapChildrenLeaves = (element, attributes = {}) => {
    if (!element) {
        return [];
    }

    const isDeepElement = DEEP_ELEMENTS.includes(element.tagName);

    if (!element.children.length || isDeepElement) {
        const allAttributes = {
            ...attributes,
            ...getAttributes(element),
            tag: element.tagName
        };

        if (element.textContent && element.textContent.trim()) {
            allAttributes.children = element.textContent;
        }

        if (isDeepElement) {
            allAttributes.childElements = [].map.call(element.children, (child) => ({
                ...getAttributes(child),
                tag: child.tagName
            }));
        }

        return [allAttributes];
    }

    let leaves = [];
    const isGroupElement = element.tagName.toLowerCase() === 'g';
    const passedOnAttributes = isGroupElement ? getAttributes(element) : {};

    Array.from(element.children).forEach((child) => {
        leaves = leaves.concat(mapChildrenLeaves(child, passedOnAttributes));
    });

    return leaves;
};

module.exports = mapChildrenLeaves;
